<template>
  <thead>
    <tr>
      <template v-for="header in headers">
        <th :key="header.value" @click="header.sortable ? $emit('sort', header.value) : null" :width="header.width">
          <v-row class="ma-0" align="center" :justify="header.align">
            <span>{{header.text}}</span>
            <template v-if="header.sortable">
              <v-icon class="sorting sort" v-if="![header.value, `-${header.value}`].includes($route.query.ordering)" small />
              <v-icon class="sorting sort-Up" v-if="$route.query.ordering === `-${header.value}`" small />
              <v-icon class="sorting sort-Down" v-if="$route.query.ordering === header.value" small />
            </template>
          </v-row>
        </th>
      </template>
    </tr>
  </thead>
</template>
<script>
export default {
  props: ['headers', 'sortable']
}
</script>
<style scoped>
.sorting.sort {
  background-image: url('../../assets/appIcon-ui--tableSort.svg');
}
.sorting.sort-Up {
  background-image: url('../../assets/appIcon-ui--tableSortUp.svg');
}
.sorting.sort-Down {
  background-image: url('../../assets/appIcon-ui--tableSortDown.svg');
}
</style>